<template lang="pug">
  .promotion-banner
    span.sephora-flame-icon.svg-icon.home
    .promotion-notification
      ul.promotion-list
        li.promotion(v-if='showMinQualifyingFreeShipping')
          a.promotion-link(:href='$t("faq.links.deliveryOptionsAndShipping", i18nSiteCountryLs)' target='_blank')
            span.h4.promotion-title(v-if='!isMobile' v-text='$t("navigation.delivery.freeShipping")')
            span.promotion-subtitle(v-html='freeShippingText')

        li.promotion(v-if='maxFreeSamples > 0')
          a.promotion-link(:href='freeSampleHeaderLinkUrl')
            template(v-if='!isMobile')
              span.h4.promotion-title(v-text='freeSampleHeaderTitle')
              span.promotion-subtitle(v-text='freeSampleHeaderText')
            template(v-else)
                span.promotion-subtitle(v-text='`${freeSampleHeaderTitle} ${freeSampleHeaderText}`')

        template(v-if='i18nSiteCountryLs === "ph"')
          li.promotion
            a.promotion-link(:href='$t("faq.links.deliveryOptionsAndShipping", i18nSiteCountryLs)')
              template(v-if='!isMobile')
                span.h4.promotion-title(v-text='$t("navigation.delivery.allPrices")')
                span.promotion-subtitle(v-text='$t("navigation.delivery.importDutyIncluded")')
              template(v-else)
                span.promotion-subtitle(v-text='`${$t("navigation.delivery.allPrices")} ${$t("navigation.delivery.importDutyIncluded")}`')
</template>

<script>
import { humanizePrice } from '@/modules/services/price-support'

export default {
  computed: {
    isMobile: () => vueSupport.isMobile,
    i18nSiteCountryLs: () => I18n.siteCountryLs,
    maxFreeSamples: () => vueSupport.header.maxFreeSamples,
    freeSampleHeaderTitle: () => vueSupport.header.freeSampleHeaderTitle,
    freeSampleHeaderText: () => vueSupport.header.freeSampleHeaderText,
    freeSampleHeaderLinkUrl: () => vueSupport.header.freeSampleHeaderLinkUrl,
    showMinQualifyingFreeShipping: () => vueSupport.header.showMinQualifyingFreeShipping,
    crossBorderCountry: () => vueSupport.crossBorderCountry,
    freeShippingText () {
      const freeShippingAmount = humanizePrice(vueSupport.common.freeShippingAmount, { precision: 0 })

      if (this.crossBorderCountry) {
        if (this.isMobile) {
          return this.$t('navigation.delivery.freeShippingFullGlobalE')
        } else {
          return this.$t('navigation.delivery.forOrdersAboveGlobalE')
        }
      } else {
        if (this.isMobile) {
          return this.$t('navigation.delivery.freeShippingFull', { freeShippingAmount })
        } else {
          return this.$t('navigation.delivery.forOrdersAbove', { freeShippingAmount })
        }
      }
    }
  },

  mounted () {
    this.initAutoScrollPromotion()
    this.addCssToPromotionBanner()
  },

  methods: {
    initAutoScrollPromotion () {
      const promotionList = document.querySelector('.promotion-list')
      const promotions = promotionList.querySelectorAll('.promotion')
      const promotionCount = promotions.length - 1
      const height = promotions[0].offsetHeight
      let count = 0

      setInterval(() => {
        if (promotionCount < count) {
          count = 0
          promotionList.style.marginTop = height * promotionCount
        }
        $(promotionList).animate({ 'margin-top': -height * count }, 300)
        count++
      }, 3000)
    },
    addCssToPromotionBanner () {
      if (this.crossBorderCountry) {
        document.querySelector('.promotion-banner').style.display = 'block'
      }
    }
  }
}
</script>

<style lang='scss' scoped>
  .sephora-flame-icon {
    width: 25px;
    height: 45px;
    background-size: 50px 50px;

    @include media-breakpoint-down(sm) {
      display: none;
    }
  }

  .promotion-banner {
    width: 100%;

    @include media-breakpoint-up(sm) {
      display: none;
    }

    @include media-breakpoint-up(lg) {
      display: inline-block;
      position: static;
      left: 75%;
      height: 50px;
      width: 210px;
    }

    .promotion-notification {
      display: block;
      background: $black;
      width: 100%;
      height: 20px;
      overflow: hidden;

      @include media-breakpoint-up(lg) {
        width: 185px;
        height: 40px;
        text-transform: uppercase;
        line-height: 18px;
        display: inline-block;
        background: $white;
      }

      .promotion {
        color: $white;

        @include media-breakpoint-up(lg) {
          height: 38px;
          padding: 2px 0;
          color: $black;
        }
      }

      .promotion-link {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        @include font-weight-medium;
        font-size: 12px;
      }

      .promotion-title {
        @include font-weight-medium;
        font-size: 12px;
        letter-spacing: 2px;
        margin-bottom: 0;

        @include media-breakpoint-up(lg) {
          font-size: 20px;
        }
      }

      .promotion-subtitle {
        text-align: center;
        display: inline-block;
        font-size: 10px;
        @include font-sephora-sans;

        @include media-breakpoint-up(lg) {
          text-align: left;
          display: block;
        }
      }
    }
  }
</style>
